/*
 * @Author: your name
 * @Date: 2021-01-14 10:48:29
 * @LastEditTime: 2021-09-27 10:34:00
 * @LastEditors: yang chenglin
 * @Description: 公告
 * @FilePath: \CJYX_DouYin\src\pages\Home\components\GetHelp\index.tsx
 */
import React, { useEffect, useState } from 'react';
import styles from './index.module.scss';
import { Servlets } from '@/service';
import { Loading } from '@alifd/next';

const GetHelp = () => {
  useEffect(() => {
    getHelpList();
  }, []);

  const [helpList, setHelpList] = useState([]); // 存放重要信息数据
  const [loadingVisible, setLoadingVisible] = useState(false);
  const getHelpList = () => { // 调后端接口获取重要信息的数据
    Servlets('getLogAndAnnouncement', {}).then((res) => {
      if (res.success) {
        setHelpList(res.data);
      }
      setLoadingVisible(false);
    });
  };
  const goHelp = (val) => {
    window.open(val);
  };

  return (
    <div className={styles.getHelpBox} style={{ marginBottom: 20 }}>
      <Loading visible={loadingVisible}>
        <div className={styles.boxTitle}>公告</div>
        <div style={{ padding: '40px' }}>
          <ul className={styles.listSize}>
            {
              helpList.map((value, index) => {
                return (
                  <li className={styles.listItem} key={index}>
                    <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                      {/* <div className={styles.itemCircle} style={{backgroundColor: "#FF9900"}}>问</div> */}
                      <div
                        className={styles.question}
                        dangerouslySetInnerHTML={{ __html: value.title }}
                      />
                    </div>
                    <div style={{ display: 'flex', alignItems: 'flex-start' }}>
                      {/* <div className={styles.itemCircle} style={{backgroundColor: "#00BB66"}}>答</div> */}
                      <div
                        className={styles.answer}
                        style={{ whiteSpace: 'pre-wrap' }}
                        dangerouslySetInnerHTML={{ __html: value.logContent.split('^').join('\n') }}
                      />
                    </div>
                  </li>
                );
              })
            }
          </ul>
        </div>
      </Loading>
    </div>
  );
};

export default GetHelp;
